import AxiosService from '@/Services/AxiosService';
import LoaderService from '@/Services/LoaderService';
import { Inject, Service } from 'vue-di-container';
import { AddRenewContractRequestModel } from '../RenewContractReques/AddRenewContractRequestModel';
import { ConnectingSenderNameModel } from './ConnectingSenderNameModel';

@Service()
export default class ConnectingSenderNameService {
    @Inject(AxiosService) public axiosService!: AxiosService;
    @Inject(LoaderService) public loaderService!: LoaderService;

    public async post(model: ConnectingSenderNameModel) {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/contract-requests';
            const result = await this.axiosService.axiosInstance.post(url, model);
            this.loaderService.HideLoader();
            return result.data;
        } catch (error) {
            this.loaderService.HideLoader();
            return false;
        }
    }
    public async ConnectingSenderName(senderName: string, crNumber: string, customerType: number, enterpriseUnifiedNumber: string): Promise<any> {
        this.loaderService.ShowLoader();

        try {
            const queryParams = new URLSearchParams({
                senderName,
                crNumber,
                customerType: customerType.toString(),
                enterpriseUnifiedNumber,
            });

            const url = `${window.$config.HostName}api/senders/get-sender-for-contract-request?${queryParams.toString()}`;
            const result = await this.axiosService.axiosInstance.get(url);

            return result.data;
        } catch (error) {
            console.error('Error in ConnectingSenderName:', error);
            return false;
        } finally {
            this.loaderService.HideLoader();
        }

    }
    public async GetForRenewContract(senderName: string, crNumber: string, customerType: number, enterpriseUnifiedNumber: string,): Promise<any> {
        this.loaderService.ShowLoader();

        try {
            const queryParams = new URLSearchParams({
                senderName,
                crNumber,
                customerType: customerType.toString(),
                enterpriseUnifiedNumber,
            });

            const url = `${window.$config.HostName}api/contract-requests/get-sender-for-contract-renew?${queryParams.toString()}`;
            const result = await this.axiosService.axiosInstance.get(url);

            return result.data;
        } catch (error) {
            console.error('Error in GetForRenewContract:', error);
            return false;
        } finally {
            this.loaderService.HideLoader();
        }
    }
    public async addContractRequestEmail(ids: string[]): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/contract-requests/send-add-contract-request-email';
            const result = await this.axiosService.axiosInstance.put(url, ids);
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }
    public async AddRenewContractRequest(model: AddRenewContractRequestModel) {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/contract-requests/renew';
            const result = await this.axiosService.axiosInstance.post(url, model);
            this.loaderService.HideLoader();
            return result.data;
        } catch (error) {
            this.loaderService.HideLoader();
            return false;
        }
    }
}
